import { Line, mixins } from 'vue-chartjs'
import colors from '@/utils/colors'
const { reactiveProp } = mixins

export const LineChart2 = {
  extends: Line,
  mixins: [reactiveProp],
  data () {
    return {
      colors: colors.cores
    }
  },
  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    },
    coloredLine: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.$refs.canvas) {
      for (let index = 0; index < this.chartData.datasets.length; index++) {
        if (!this.chartData.datasets[index].backgroundColor) {
          this.chartData.datasets[index].backgroundColor = this.montarCor(this.colors[index])
        } else {
          if (this.gradiente) {
            this.chartData.datasets[index].backgroundColor = this.gradient(this.chartData.datasets[index].backgroundColor)
          }
        }

        if (this.coloredLine) {
          this.chartData.datasets[index].borderColor = this.montarCor(this.colors[index])
        }
      }

      Chart.plugins.register({
        id: 'paddingBelowLegends',
        beforeInit: function(chart, options) {
          chart.legend.afterFit = function() {
            this.height = this.height + 15
          }
        }
      })

      this.renderChart(
        this.chartData,
        this.options
      )
      this.htmlLegend = this.generateLegend()
    }
  },
  methods: {
    montarCor (cor) {
      if (this.gradiente) {
        return this.gradient(cor)
      } else {
        return 'rgb(' + cor + ')'
      }
    },
    gradient (color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

      gradient.addColorStop(0.4, 'rgba(' + color + ', 1)')
      gradient.addColorStop(0.7, 'rgba(' + color + ', 0.8)')
      gradient.addColorStop(1, 'rgba(' + color + ', 0.6)')

      return gradient
    }
  },
  watch: {
    chartData () {
      for (let index = 0; index < this.$data._chart.data.datasets.length; index++) {
        if (!this.$data._chart.data.datasets[index].backgroundColor) {
          this.$data._chart.data.datasets[index].backgroundColor = this.montarCor(this.colors[index])
        } else {
          if (this.gradiente) {
            this.$data._chart.data.datasets[index].backgroundColor = this.gradient(this.$data._chart.data.datasets[index].backgroundColor)
          }
        }

        if (this.coloredLine) {
          this.$data._chart.data.datasets[index].borderColor = this.montarCor(this.colors[index])
        }
      }

      this.$data._chart.update()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LineChart2.js